<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1">{{
                "organizationList" | translate
              }}</span>
            </h3>
            <div class="card-toolbar">
              <!-- Filter btn -->
              <button
                class="btn btn-icon btn-active-light-primary cursor-pointer"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
              >
                <i class="fa-solid fa-filter"></i>
              </button>
              <!-- Create new organization btn -->
              <a
                [routerLink]="['/organization/create']"
                style="margin-left: 30px"
                class="btn btn-sm fw-bold btn-primary"
                >{{ "createOrganization" | translate }}</a
              >
            </div>
          </div>

          <!-- Organization List -->
          <div class="card-body py-3">
            <div class="table-responsive">
              <!-- Filters -->
              <div class="collapse mb-8" id="collapseExample">
                <form (submit)="filterOrganizationList($event)">
                  <div class="row">
                    <!-- Name -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="name" class="form-label">{{
                        "name" | translate
                      }}</label>
                      <input
                        [(ngModel)]="filterForm.name"
                        type="text"
                        class="form-control"
                        id="name"
                        name="name"
                        placeholder="{{ 'filterByName' | translate }}"
                      />
                    </div>
                    <!-- Customer Code -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="Customer Code" class="form-label">{{
                        "customerCode" | translate
                      }}</label>
                      <select
                        [(ngModel)]="filterForm.customerCode"
                        class="form-select cursor-pointer"
                        aria-label="Small select example"
                        name="Customer Code"
                      >
                        <option [ngValue]="null" selected disabled>
                          {{ "selectCustomerCode" | translate }}
                        </option>
                        <option
                          *ngFor="let customerCode of customerCodes"
                          [value]="customerCode?.code"
                        >
                          {{ customerCode?.code }}
                        </option>
                      </select>
                    </div>

                    <!-- Location -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="location" class="form-label">{{
                        "location" | translate
                      }}</label>
                      <input
                        [(ngModel)]="filterForm.location"
                        type="text"
                        class="form-control"
                        id="location"
                        name="location"
                        placeholder="{{ 'filterByLocation' | translate }}"
                      />
                    </div>
                    <!-- Start Create Date Filter -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="startCreatedDate" class="form-label">{{
                        "startCreatedDate" | translate
                      }}</label>
                      <input
                        [(ngModel)]="filterForm.startCreatedDate"
                        [value]="filterForm.startCreatedDate"
                        type="date"
                        class="form-control"
                        id="startCreatedDate"
                        name="startCreatedDate"
                        [max]="maxDate"
                      />
                    </div>
                    <!-- End Create Date Filter -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="endCreatedDate" class="form-label">{{
                        "endCreatedDate" | translate
                      }}</label>
                      <input
                        [(ngModel)]="filterForm.endCreatedDate"
                        [value]="filterForm.endCreatedDate"
                        type="date"
                        class="form-control"
                        id="endCreatedDate"
                        name="endCreatedDate"
                        [max]="maxDate"
                      />
                    </div>
                    <!-- Email Filter -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="email" class="form-label">{{
                        "email" | translate
                      }}</label>
                      <input
                        [(ngModel)]="filterForm.email"
                        type="email"
                        class="form-control"
                        id="email"
                        name="email"
                        placeholder="{{ 'filterByEmail' | translate }}"
                      />
                    </div>
                    <!-- Total Analysis Filter -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="totalAnalysis" class="form-label">{{
                        "totalAnalysis" | translate
                      }}</label>
                      <input
                        [(ngModel)]="filterForm.totalAnalysis"
                        type="number"
                        class="form-control"
                        id="totalAnalysis"
                        name="totalAnalysis"
                        placeholder="{{ 'filterByTotalAnalysis' | translate }}"
                      />
                    </div>
                  </div>
                  <!-- Filter Action Buttons -->
                  <div
                    class="filter-btn mt-2 d-flex align-items-center gap-4 justify-content-end"
                  >
                    <button
                      (click)="clearFilters()"
                      type="button"
                      class="btn btn-secondary btn-sm cursor-pointer"
                    >
                      {{ "clear" | translate }}
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary btn-sm cursor-pointer"
                    >
                      {{ "filter" | translate }}
                    </button>
                  </div>
                </form>
              </div>
              <!-- Organization Table Loading -->
              <div
                *ngIf="organizationListLoading; else organizationList"
                class="d-flex justify-content-center pb-4"
              >
                <div class="spinner-border text-danger" role="status">
                  <span class="visually-hidden"
                    >organizationListLoading...</span
                  >
                </div>
              </div>
              <ng-template #organizationList>
                <!-- If no organization available -->
                <div
                  *ngIf="
                    organizations && !organizations.length;
                    else organizationListTable
                  "
                  class="card-body py-3 text-center fs-5"
                >
                  {{ "noOrganizationsAvailable" | translate }}
                </div>
                <!-- Organization Table -->
                <ng-template #organizationListTable>
                  <table
                    class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3"
                  >
                    <thead>
                      <tr class="fw-bold text-muted">
                        <th class="w-25px">
                          <div
                            class="form-check form-check-sm form-check-custom form-check-solid"
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value="1"
                              data-kt-check="true"
                              data-kt-check-target=".widget-13-check"
                            />
                          </div>
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "name" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "customerCode" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "location" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "created" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "email" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "totalAnalysis" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "invoice" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-80px fw-bold">
                          {{ "actions" | translate }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let organization of organizations">
                        <td>
                          <div
                            class="form-check form-check-sm form-check-custom form-check-solid"
                          >
                            <input
                              class="form-check-input widget-13-check"
                              type="checkbox"
                              value="1"
                            />
                          </div>
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ organization.name || "-" }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ organization?.customerCode || "-" }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ organization?.location || "-" }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{
                            organization?.createdDate
                              ? (organization?.createdDate
                                | date : "dd-MM-yyyy")
                              : "-"
                          }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ organization?.email || "-" }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ organization?.totalAnalysis || "-" }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ organization?.invoice || "-" }}
                        </td>
                        <td>
                          <!-- Edit Organization -->
                          <a
                            [routerLink]="[
                              '/organization/edit',
                              organization?.id
                            ]"
                            class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                            [title]="'edit' | translate"
                            ><i class="fa-regular fa-pen-to-square"></i
                          ></a>
                          <!-- Delete Organization -->
                          <a
                            (click)="deleteModalId = organization?.id || ''"
                            data-bs-toggle="modal"
                            [attr.data-bs-target]="
                              '#exampleModal-' + deleteModalId
                            "
                            class="delete btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                            [title]="'delete' | translate"
                            ><i class="fa-regular fa-trash-can"></i
                          ></a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ng-template>
              </ng-template>
            </div>
          </div>
        </div>
        <!-- Pagination -->
        <div class="d-flex flex-stack flex-wrap pt-10">
          <div class="d-flex align-items-center gap-6">
            <div class="flex align-items-center">
              <label
                for="pageSizeSelect"
                class="me-2 fs-6 fw-semibold text-gray-700"
                >Page Size:</label
              >
              <select
                id="pageSizeSelect"
                (change)="changePageSize($event)"
                class="cursor-pointer outline-none"
              >
                <option *ngFor="let size of pageSizes" [value]="size">
                  {{ size }}
                </option>
              </select>
            </div>
            <div class="fs-6 fw-semibold text-gray-700">
              Showing {{ organizations.length }} of
              {{ totalOrganization }} organizations
            </div>
          </div>
          <ul class="pagination">
            <li
              class="page-item previous cursor-pointer"
              [class.disabled]="currentPage === 1"
            >
              <a class="page-link" (click)="changePage(currentPage - 1)">
                <i class="previous"></i>
              </a>
            </li>
            <li
              *ngFor="let page of [].constructor(totalPage); let i = index"
              class="page-item cursor-pointer"
              [class.active]="currentPage === i + 1"
            >
              <a class="page-link" (click)="changePage(i + 1)">{{ i + 1 }}</a>
            </li>
            <li
              class="page-item next cursor-pointer"
              [class.disabled]="currentPage === totalPage"
            >
              <a class="page-link" (click)="changePage(currentPage + 1)">
                <i class="next"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Organization Modal -->
<div
  class="modal fade"
  [id]="'exampleModal-' + deleteModalId"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="exampleModalLabel">
          {{ "deleteOrganization" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4">
        {{ "deleteOrganizationModal" | translate }}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "cancel" | translate }}
        </button>
        <button
          (click)="deleteOrganization(deleteModalId)"
          type="button"
          class="btn btn-danger cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "delete" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
